// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               unknown
// source: Protos/V1/Marketplace.proto

/* eslint-disable */
import Long from "long";
import type { CallContext, CallOptions } from "nice-grpc-common";
import {
  BrowseMarketplaceRequest,
  BrowseMarketplaceResponse,
  CheckEntitlementRequest,
  CheckEntitlementResponse,
  CreateMarketplaceItemRequest,
  CreateMarketplaceItemResponse,
  CreateProviderProfileRequest,
  CreateProviderProfileResponse,
  GetMarketplaceItemRequest,
  GetMarketplaceItemResponse,
  GetMyPurchasesRequest,
  GetMyPurchasesResponse,
  GetPendingProviderProfilesRequest,
  GetPendingProviderProfilesResponse,
  GetPendingReviewItemsRequest,
  GetPendingReviewItemsResponse,
  GetProviderProfileRequest,
  GetProviderProfileResponse,
  PurchaseMarketplaceItemRequest,
  PurchaseMarketplaceItemResponse,
  ReviewMarketplaceItemRequest,
  ReviewMarketplaceItemResponse,
  ReviewProviderProfileRequest,
  ReviewProviderProfileResponse,
  UpdateMarketplaceItemRequest,
  UpdateMarketplaceItemResponse,
  UpdateProviderProfileRequest,
  UpdateProviderProfileResponse,
  UploadPackageRequest,
  UploadPackageResponse,
} from "./Models/MarketplaceModels";

export const protobufPackage = "daisi.protos.v1";

export type MarketplaceProtoDefinition = typeof MarketplaceProtoDefinition;
export const MarketplaceProtoDefinition = {
  name: "MarketplaceProto",
  fullName: "daisi.protos.v1.MarketplaceProto",
  methods: {
    /** Catalog */
    browseMarketplace: {
      name: "BrowseMarketplace",
      requestType: BrowseMarketplaceRequest,
      requestStream: false,
      responseType: BrowseMarketplaceResponse,
      responseStream: false,
      options: {},
    },
    getMarketplaceItem: {
      name: "GetMarketplaceItem",
      requestType: GetMarketplaceItemRequest,
      requestStream: false,
      responseType: GetMarketplaceItemResponse,
      responseStream: false,
      options: {},
    },
    /** Provider item management */
    createMarketplaceItem: {
      name: "CreateMarketplaceItem",
      requestType: CreateMarketplaceItemRequest,
      requestStream: false,
      responseType: CreateMarketplaceItemResponse,
      responseStream: false,
      options: {},
    },
    updateMarketplaceItem: {
      name: "UpdateMarketplaceItem",
      requestType: UpdateMarketplaceItemRequest,
      requestStream: false,
      responseType: UpdateMarketplaceItemResponse,
      responseStream: false,
      options: {},
    },
    uploadPackage: {
      name: "UploadPackage",
      requestType: UploadPackageRequest,
      requestStream: true,
      responseType: UploadPackageResponse,
      responseStream: false,
      options: {},
    },
    /** Purchase & entitlement */
    purchaseMarketplaceItem: {
      name: "PurchaseMarketplaceItem",
      requestType: PurchaseMarketplaceItemRequest,
      requestStream: false,
      responseType: PurchaseMarketplaceItemResponse,
      responseStream: false,
      options: {},
    },
    getMyPurchases: {
      name: "GetMyPurchases",
      requestType: GetMyPurchasesRequest,
      requestStream: false,
      responseType: GetMyPurchasesResponse,
      responseStream: false,
      options: {},
    },
    checkEntitlement: {
      name: "CheckEntitlement",
      requestType: CheckEntitlementRequest,
      requestStream: false,
      responseType: CheckEntitlementResponse,
      responseStream: false,
      options: {},
    },
    /** Provider profiles */
    getProviderProfile: {
      name: "GetProviderProfile",
      requestType: GetProviderProfileRequest,
      requestStream: false,
      responseType: GetProviderProfileResponse,
      responseStream: false,
      options: {},
    },
    createProviderProfile: {
      name: "CreateProviderProfile",
      requestType: CreateProviderProfileRequest,
      requestStream: false,
      responseType: CreateProviderProfileResponse,
      responseStream: false,
      options: {},
    },
    updateProviderProfile: {
      name: "UpdateProviderProfile",
      requestType: UpdateProviderProfileRequest,
      requestStream: false,
      responseType: UpdateProviderProfileResponse,
      responseStream: false,
      options: {},
    },
    /** Admin review */
    getPendingReviewItems: {
      name: "GetPendingReviewItems",
      requestType: GetPendingReviewItemsRequest,
      requestStream: false,
      responseType: GetPendingReviewItemsResponse,
      responseStream: false,
      options: {},
    },
    reviewMarketplaceItem: {
      name: "ReviewMarketplaceItem",
      requestType: ReviewMarketplaceItemRequest,
      requestStream: false,
      responseType: ReviewMarketplaceItemResponse,
      responseStream: false,
      options: {},
    },
    getPendingProviderProfiles: {
      name: "GetPendingProviderProfiles",
      requestType: GetPendingProviderProfilesRequest,
      requestStream: false,
      responseType: GetPendingProviderProfilesResponse,
      responseStream: false,
      options: {},
    },
    reviewProviderProfile: {
      name: "ReviewProviderProfile",
      requestType: ReviewProviderProfileRequest,
      requestStream: false,
      responseType: ReviewProviderProfileResponse,
      responseStream: false,
      options: {},
    },
  },
} as const;

export interface MarketplaceProtoServiceImplementation<CallContextExt = {}> {
  /** Catalog */
  browseMarketplace(
    request: BrowseMarketplaceRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<BrowseMarketplaceResponse>>;
  getMarketplaceItem(
    request: GetMarketplaceItemRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<GetMarketplaceItemResponse>>;
  /** Provider item management */
  createMarketplaceItem(
    request: CreateMarketplaceItemRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<CreateMarketplaceItemResponse>>;
  updateMarketplaceItem(
    request: UpdateMarketplaceItemRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<UpdateMarketplaceItemResponse>>;
  uploadPackage(
    request: AsyncIterable<UploadPackageRequest>,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<UploadPackageResponse>>;
  /** Purchase & entitlement */
  purchaseMarketplaceItem(
    request: PurchaseMarketplaceItemRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<PurchaseMarketplaceItemResponse>>;
  getMyPurchases(
    request: GetMyPurchasesRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<GetMyPurchasesResponse>>;
  checkEntitlement(
    request: CheckEntitlementRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<CheckEntitlementResponse>>;
  /** Provider profiles */
  getProviderProfile(
    request: GetProviderProfileRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<GetProviderProfileResponse>>;
  createProviderProfile(
    request: CreateProviderProfileRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<CreateProviderProfileResponse>>;
  updateProviderProfile(
    request: UpdateProviderProfileRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<UpdateProviderProfileResponse>>;
  /** Admin review */
  getPendingReviewItems(
    request: GetPendingReviewItemsRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<GetPendingReviewItemsResponse>>;
  reviewMarketplaceItem(
    request: ReviewMarketplaceItemRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<ReviewMarketplaceItemResponse>>;
  getPendingProviderProfiles(
    request: GetPendingProviderProfilesRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<GetPendingProviderProfilesResponse>>;
  reviewProviderProfile(
    request: ReviewProviderProfileRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<ReviewProviderProfileResponse>>;
}

export interface MarketplaceProtoClient<CallOptionsExt = {}> {
  /** Catalog */
  browseMarketplace(
    request: DeepPartial<BrowseMarketplaceRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<BrowseMarketplaceResponse>;
  getMarketplaceItem(
    request: DeepPartial<GetMarketplaceItemRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<GetMarketplaceItemResponse>;
  /** Provider item management */
  createMarketplaceItem(
    request: DeepPartial<CreateMarketplaceItemRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<CreateMarketplaceItemResponse>;
  updateMarketplaceItem(
    request: DeepPartial<UpdateMarketplaceItemRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<UpdateMarketplaceItemResponse>;
  uploadPackage(
    request: AsyncIterable<DeepPartial<UploadPackageRequest>>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<UploadPackageResponse>;
  /** Purchase & entitlement */
  purchaseMarketplaceItem(
    request: DeepPartial<PurchaseMarketplaceItemRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<PurchaseMarketplaceItemResponse>;
  getMyPurchases(
    request: DeepPartial<GetMyPurchasesRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<GetMyPurchasesResponse>;
  checkEntitlement(
    request: DeepPartial<CheckEntitlementRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<CheckEntitlementResponse>;
  /** Provider profiles */
  getProviderProfile(
    request: DeepPartial<GetProviderProfileRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<GetProviderProfileResponse>;
  createProviderProfile(
    request: DeepPartial<CreateProviderProfileRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<CreateProviderProfileResponse>;
  updateProviderProfile(
    request: DeepPartial<UpdateProviderProfileRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<UpdateProviderProfileResponse>;
  /** Admin review */
  getPendingReviewItems(
    request: DeepPartial<GetPendingReviewItemsRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<GetPendingReviewItemsResponse>;
  reviewMarketplaceItem(
    request: DeepPartial<ReviewMarketplaceItemRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<ReviewMarketplaceItemResponse>;
  getPendingProviderProfiles(
    request: DeepPartial<GetPendingProviderProfilesRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<GetPendingProviderProfilesResponse>;
  reviewProviderProfile(
    request: DeepPartial<ReviewProviderProfileRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<ReviewProviderProfileResponse>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;
